import React from "react";
import { EsseCloseSquareO } from "lovedicons/dist/esseO";

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div
      // className="fixed inset-0 p-10 z-50 bg-black md:bg-red-500 lg:bg-green-500 xl:bg-purple-400 bg-opacity-50 flex justify-center items-center"
      className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center"
      onClick={onClose}
    >
      <div
        className="p-3 w-3/4 h-3/4 flex flex-col bg-white rounded-2xl shadow-lg"
        onClick={(event) => event.stopPropagation()} // Prevents click from propagating
      >
        <button
          onClick={onClose}
          className="flex justify-end text-black p-2 rounded-full"
        >
          <EsseCloseSquareO className="w-6 h-6" />
        </button>
        {/* <div className="">{children}</div> */}
        {children}
      </div>
    </div>
  );
};

export default Modal;
